export default __webpack_public_path__ + "static/media/Phone icon - Light.e5e58826.svg";